module.exports = __webpack_public_path__ + "static/media/quote-left.281af4c0.svg";